import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button, Card, Backdrop, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CardContent, CircularProgress } from '@mui/material'; // <-- Import CircularProgress
import axios from 'axios';
import { BASE_URL } from '../../App';
import Grid from '@mui/material/Grid';
import CRILOGO from '../image/CRILogoEnglishold.png';
//import { styled } from '@mui/joy/styles';
//import { Box } from '@mui/joy';

const Item = () => (
  <Box
    sx={{
      backgroundColor: '#fff',
      padding: 2,
      textAlign: 'center',
      borderRadius: 4,
      color: 'text.secondary',
      border: '1px solid black',
      '&:hover': {
        backgroundColor: 'action.hover',
        borderColor: 'primary.main',
      },
    }}
  >
    Content
  </Box>
);

const Winding_Wire_Report = () => {
  const [branch, setBranch] = useState('');
  const [status, setStatus] = useState('');
  const [showTable, setShowTable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [tableData, setTableData] = useState([]);
  const [reportProcessed, setReportProcessed] = useState(false);
  const [branchOptions, setBranchOptions] = useState([]);
  const [serviceCenterOptions, setServiceCenterOptions] = useState([]);
  const [serviceCenter, setServiceCenter] = useState('');
  const [branchAddress, setBranchAddress] = useState('');
  const [serviceCenterAddress, setServiceCenterAddress] = useState('');
  const [branchName, setBranchName] = useState('');
  const login_id = localStorage.getItem("LOGIN_ID");
  const BRANCH_CODE = localStorage.getItem("BRANCH_CODE");


  const statusOptions = [
    { Status: 'APPROVED' },
    { Status: 'REJECTED' },
    { Status: 'YET TO BE APPROVED' },
  ];

  //const logo = '/image/CRILogoEnglishold.jpg';

  useEffect(() => {
    const fetchBranches = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await axios.post(BASE_URL + '/getfillBranch', {
          login_id: login_id,
          branch_code: BRANCH_CODE,
        });
        const branches = response.data.branchlist;

       
        if (!branches || branches.length === 0) {
          setError('No branches found.');
          return;
        }

    
        const filteredBranches = branches.filter(branch => branch.name !== '-ALL-');
        console.log('Filtered branches:', filteredBranches); 

        setBranchOptions(filteredBranches); 
      } catch (error) {
        setError('Error fetching branches');
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchBranches();
  }, []);

  useEffect(() => {
    const fetchServiceCenters = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await axios.post(BASE_URL + '/getservicesenterdetails', {
          branch,
          status,
        });
        const serviceCenters = response.data?.serviceCenters || [];
        setServiceCenterOptions(serviceCenters);
      } catch (error) {
        setError('Error fetching service centers');
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    if (branch && status) {
      fetchServiceCenters();
    }
  }, [branch, status]);

  useEffect(() => {
    const fetchBranchName = async () => {
      if (branch) {
        try {
          const response = await axios.post(BASE_URL + '/getBranchName', { branchCode: branch });
          setBranchName(response.data.branchName || 'Unknown Branch');
        } catch (error) {
          console.error('Error fetching branch name:', error);
        }
      }
    };

    fetchBranchName();
  }, [branch]);

  useEffect(() => {
    const fetchBranchAddress = async () => {
      if (branch && serviceCenter) {
        try {
          const response = await axios.post(BASE_URL + '/getaddressdetails', {
            branchCode: branch,
            serviceCenterCode: serviceCenter,
          });
          const branchName = response.data.branchName || '';
          const branchAddress = response.data.address || '';
          const serviceCenterAddress = response.data.serviceCenterAddress || '';

          setBranchName(branchName);
          setBranchAddress(branchAddress);
          setServiceCenterAddress(serviceCenterAddress);
        } catch (error) {
          console.error('Error fetching branch address:', error);
        }
      }
    };

    fetchBranchAddress();
  }, [branch, serviceCenter]);

  const handleViewTable = async () => {
    if (!branch || !status || !serviceCenter) {
      setError('Please select branch, status, and service center before viewing data.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const response = await axios.post(BASE_URL + '/getviewdata', {
        ddlbranch: branch,
        selectedItemValue: status,
        ddldealercode: serviceCenter,
      });
      setTableData(response.data);
      setReportProcessed(true);
    } catch (error) {
      setError('Error fetching data');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = () => {
    const currentDate = new Date().toLocaleDateString();
    const serviceCenterName = serviceCenterOptions.find(option => option.servicecentercode === serviceCenter)?.servicecentername || 'N/A';
    const serviceCenterCode = serviceCenterOptions.find(option => option.servicecentercode === serviceCenter)?.servicecentercode || 'N/A';
  
    const printContent = document.getElementById('table-to-print').outerHTML;
  
    // const logoUrl = CRILOGO;
  
    const branchAddressToPrint = branchAddress || 'Branch address not available';
    const serviceCenterAddressToPrint = serviceCenterAddress || 'Service center address not available';
    
    const headerContent = `
      <div style="padding: 12px; text-align: center; font-weight: bold;">
        <div style="display: flex; justify-content: space-between; border: 1px solid black; padding: 12px;">
          <div style="flex: 1;">
            <div style="text-align: left;">FROM :</div>
            <div style="text-align: left; margin-top: 5px;">${branchAddressToPrint}</div>
          </div>
          <div style="flex: 1; display: flex; justify-content: center; align-items: center;">
           <img
        src=${CRILOGO}
        alt="Logo"
        style={{
         
          maxWidth: '80%',
          maxHeight: '120px',
         
        }}
      />
          </div>
        </div>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid black;">
          <tr>
            <td rowspan="4" style="border: 1px solid black; padding: 8px; vertical-align: top;">
              <div style="text-align: left;">TO:</div>
              <div style="text-align: left; margin-top: 5px;">${serviceCenterAddressToPrint}</div>
            </td>
            <td style="border: 1px solid black; padding: 8px;">DATE :</td>
            <td style="border: 1px solid black; padding: 8px;">${currentDate}</td>
          </tr>
          <tr>
            <td style="border: 1px solid black; padding: 8px;">Service center code:</td>
            <td style="border: 1px solid black; padding: 8px;">${serviceCenterCode}</td>
          </tr>
          <tr>
            <td style="border: 1px solid black; padding: 8px;">Service center name:</td>
            <td style="border: 1px solid black; padding: 8px;">${serviceCenterName}</td>
          </tr>
          <tr>
            <td style="border: 1px solid black; padding: 8px;">Report Type :</td>
            <td style="border: 1px solid black; padding: 8px;">WINDING WIRE RATE CHANGE REPORT</td>
          </tr>
        </table>
      </div>
    `;
  
    const printWindow = window.open('', '', 'height=650, width=800');
    printWindow.document.write('<html><head><title>Report</title></head><body>');
    printWindow.document.write(headerContent + printContent);
    printWindow.document.write(`
      <style>
        table, th, td {
          border: 1px solid black;
          border-collapse: collapse;
        }
        th, td {
          padding: 8px;
          text-align: center;
        }
        .footer {
          position: relative;
          padding: 12px;
          text-align: right;
          font-weight: bold;
          bottom: 0;
        }
      </style>
    `);
    printWindow.document.write(`
      <div class="footer">
        <br>
        Branch Manager's Signature: ______________
      </div>
    `);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
  };
  return (
    <center>
      <Card className="shadow bg-white rounded" sx={{ padding: 5, width: '80%' }}>
    <Grid container spacing={2} direction="row" alignItems="center">
  <Grid item xs={4}>
    <Autocomplete
      disablePortal
      options={branchOptions}
      getOptionLabel={(option) => `${option.code} - ${option.name}`}
      renderInput={(params) => <TextField {...params} label="Branch" />}
      onChange={(event, value) => setBranch(value ? value.code : '')}
      sx={{ width: '100%' }}
    />
  </Grid>

  <Grid item xs={4}>
    <Autocomplete
      disablePortal
      options={statusOptions}
      getOptionLabel={(option) => `${option.Status}`}
      renderInput={(params) => <TextField {...params} label="Status" />}
      onChange={(event, value) => setStatus(value ? value.Status : '')}
      sx={{ width: '100%' }}  
    />
  </Grid>

  <Grid item xs={4}>
    <Autocomplete
      disablePortal
      options={serviceCenterOptions}
      getOptionLabel={(option) => `${option.servicecentercode} - ${option.servicecentername}`}
      renderInput={(params) => <TextField {...params} label="Service Center" />}
      onChange={(event, value) => setServiceCenter(value ? value.servicecentercode : '')}
      sx={{ width: '100%' }} 
    />
  </Grid>
</Grid>
      

      <Box sx={{ display: 'flex', gap: 2, marginTop: 2, ml: 2 }}>
        <Button variant="contained" color="primary" style={{ width: '250px' }} onClick={handleViewTable}>
          View
        </Button>
        <Button
          variant="contained"
          color="success"
          style={{ width: '250px' }}
          onClick={handlePrint}
          disabled={status !== 'APPROVED'}
        >
          Print
        </Button>
      </Box>

      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress size={40} color="success" />
      </Backdrop>

      {error && <Typography color="error" variant="body2" sx={{ marginTop: 2 }}>{error}</Typography>}

      {reportProcessed && tableData.length > 0 && (
        //<Grid item xs={12}>
        <Card sx={{ marginTop: 2, padding: 5, display: "flex", justifyContent: 'flex-start', alignItems: 'flex-start', width: '100%', maxWidth: '1200px' }}>

          <TableContainer component={Paper} sx={{ border: '1px solid black', maxHeight: 570, overflowY: 'auto' }}>
            <Table stickyHeader id="table-to-print" sx={{ border: '1px solid black' }}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ backgroundColor: '#1976d2', color: 'white', border: '1px solid black' }}>PRODUCT SUB GROUP</TableCell>
                  <TableCell sx={{ backgroundColor: '#1976d2', color: 'white', border: '1px solid black' }}>DESCRIPTION</TableCell>
                  <TableCell sx={{ backgroundColor: '#1976d2', color: 'white', border: '1px solid black' }}>HP</TableCell>
                  <TableCell sx={{ backgroundColor: '#1976d2', color: 'white', border: '1px solid black' }}>WIRE RATE</TableCell>
                  <TableCell sx={{ backgroundColor: '#1976d2', color: 'white', border: '1px solid black' }}>LABOUR CHARGES</TableCell>
                  <TableCell sx={{ backgroundColor: '#1976d2', color: 'white', border: '1px solid black' }}>STATUS</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell sx={{ border: '1px solid black' }}>{row.PSG}</TableCell>
                    <TableCell sx={{ border: '1px solid black' }}>{row.PSGDESC}</TableCell>
                    <TableCell sx={{ border: '1px solid black' }}>{row.HP}</TableCell>
                    <TableCell  align="right" sx={{ border: '1px solid black' }}>{row.WIRERATE}</TableCell>
                    <TableCell  align="right" sx={{ border: '1px solid black' }}>{row.labourcharge}</TableCell>
                    <TableCell sx={{
                      border: '1px solid black',
                      color: row.STATUS === 'APPROVED' ? 'green' : row.STATUS === 'YET TO BE APPROVED' ? 'yellow' : row.STATUS === 'REJECTED' ? 'red' : 'black',
                      fontWeight: 'bold',
                    }}>
                      {row.STATUS}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </Card>
        //</Grid>
      )}
    </Card>
    </center >
  );
};

export default Winding_Wire_Report;













